import { combineEpics, Epic } from 'redux-observable';

import { Action } from '../../actions';
import {
    HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE,
    HandleRecommendationsGridColumnsWidthUpdateAction,
    updateRecommendationsColumnsWidthData
} from '../../actions/recommendations-grid';
import { getColumnsWidthSettings } from '../../service/ActionHelpers';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';

export const handleRecommendationsGridColumnsWidthUpdateEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$
        .ofType(HANDLE_RECOMMENDATIONS_GRID_COLUMNS_WIDTH_UPDATE)
        .map((action: HandleRecommendationsGridColumnsWidthUpdateAction) => {
            const { columnsSettings } = store$.value.recommendationsGrid;

            const settings = getColumnsWidthSettings(
                columnsSettings,
                action.key,
                action.width,
                action.recommendationType,
                false
            );
            LocalStorage.setItem(StorageKeyType.recommendationSettings, settings);

            return updateRecommendationsColumnsWidthData(settings);
        });
};

export const recommendationsGridHelpersEpic = combineEpics(handleRecommendationsGridColumnsWidthUpdateEpic);
